<template>
  <div class="pa-connections-list-content-header" ref="header">
    <div class="pa-header">マイポットに追加</div>
    <div class="pa-description">
      <p>このキャラクターを追加するマイポットを選択してください。</p>
    </div>
  </div>
</template>

<script>
export default {
  methods : {
    offsetHeight(){
      return this.$refs.header.offsetHeight;
    }
  }
}
</script>

<style lang="scss">
.pa-connections-list-content-header{
  width:97%;
  margin:.8rem auto .4rem;
  background-color:#CCAA8B;

  .pa-header{
    color:#7F4F16;
    font-size:1.5rem;
    line-height: 1.5rem;
    text-align: center;
    width:95%;
    margin:0 auto;
    padding:.5rem 0 .3rem;
    border-bottom: 3px solid #C49065;
  }

  .pa-description{
    width:95%;
    margin:0 auto;
    padding:.2rem 0 .5rem;
    color: #7C5E49;
  }
}
</style>